var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props),
    React.createElement("path", { fill: "#303030", fillRule: "evenodd", d: "M8.5 11.5a1 1 0 1 0 2 0 1 1 0 0 0-2 0zm2.938-.497A.627.627 0 0 1 11.5 11H14c.667 0 .667 1 0 1h-2.5a.627.627 0 0 1-.062-.003 2 2 0 0 1-3.876 0A.627.627 0 0 1 7.5 12H2c-.667 0-.667-1 0-1h5.5c.021 0 .042.001.062.003a2 2 0 0 1 3.876 0zM5.5 4.5a1 1 0 1 0 2 0 1 1 0 0 0-2 0zm2.938-.497A.627.627 0 0 1 8.5 4H14c.667 0 .667 1 0 1H8.5a.627.627 0 0 1-.062-.003 2 2 0 0 1-3.876 0A.627.627 0 0 1 4.5 5H2c-.667 0-.667-1 0-1h2.5c.021 0 .042.001.062.003a2 2 0 0 1 3.876 0z" })
  );
});